import { chakra } from '@chakra-ui/react';
import React from 'react';

import type { TimeFormat } from 'types/settings';

import { useSettingsContext } from 'lib/contexts/settings';
import dayjs from 'lib/date/dayjs';
import useTimeAgoIncrement from 'lib/hooks/useTimeAgoIncrement';
import { Skeleton } from 'toolkit/chakra/skeleton';
import { Tooltip } from 'toolkit/chakra/tooltip';

type Props = {
  timestamp?: string | number | null;
  fallbackText?: string;
  isLoading?: boolean;
  enableIncrement?: boolean;
  className?: string;
  timeFormat?: TimeFormat;
  refreshTick?: number;
};

const TimeWithTooltip = ({
  timestamp,
  fallbackText,
  isLoading,
  enableIncrement,
  className,
  timeFormat: timeFormatProp,
  refreshTick,
}: Props) => {
  const settings = useSettingsContext();
  const timeFormat = timeFormatProp || settings?.timeFormat || 'relative';
  const timeAgo = useTimeAgoIncrement(
    timestamp || '',
    enableIncrement && !isLoading && timeFormat === 'relative',
  );

  // const timeAgo = React.useMemo(() => {
  //   if (!timestamp) return "";

  //   return dayjs(timestamp).fromNow();
  // }, [timestamp, refreshTick]);

  // if (!timestamp && !fallbackText) {
  //   return null;
  // }

  const [ , forceUpdate ] = React.useState(0);

  React.useEffect(() => {
    if (!enableIncrement) return;

    const id = setInterval(() => {
      forceUpdate((x) => x + 1);
    }, 1000);

    return () => clearInterval(id);
  }, [ enableIncrement ]);

  const content = (() => {
    if (!timestamp) {
      return fallbackText;
    }

    if (timeFormat === 'relative') {
      return (
        <Tooltip content={ dayjs(timestamp).format('llll') }>
          <span>{ timeAgo }</span>
        </Tooltip>
      );
    }

    return (
      <Tooltip content={ timeAgo }>
        <span>{ dayjs(timestamp).format('lll') }</span>
      </Tooltip>
    );
  })();

  return (
    <Skeleton loading={ isLoading } className={ className }>
      { content }
    </Skeleton>
  );
};

export default chakra(TimeWithTooltip);
